<template lang="html">
  <div id="app">
    <div class="container-scroller">
      <app-header/>
      <div class="container-fluid page-body-wrapper">
        <app-sidebar/>
        <div class="main-panel">
          <div class="content-wrapper">
             <template v-if="getSpinnerStatus">
                <div class="ccadmSpinner">
                  <span :class="'spinner ' + getCurrentUi_spinnerClass.class"></span>
                </div>                
              </template>
            <router-view></router-view>
          </div>
          <!-- content wrapper ends -->
          <app-footer/>
        </div>
        <!-- main panel ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>
<style>
.btn i {
    margin: auto!important;
    padding: .3em;
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters} from "vuex"
import AppHeader from '../src/components/partials/AppHeader'
import AppSidebar from '../src/components/partials/AppSidebar'
import AppFooter from '../src/components/partials/AppFooter'
import axios from 'axios'
import store from './store/store'
import VueAxios from 'vue-axios'
export default{
  name: 'app',
  components: {
    AppHeader,
    AppSidebar,
    AppFooter
  },
  methods:{
    ...mapActions([
      'setBaseUrl'
    ])
  },
  watch:{
    $route (to, from){
        console.log(from.name +" -> "+to.name);
        if(to.name == 'price_configurator') {
          window.addEventListener('scroll', this.allineaMenu, true);
        } else {
          window.removeEventListener('scroll', this.allineaMenu, true);
          document.querySelector("#sidebar").style.transform = null;
        }
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentUi_spinnerClass','getSpinnerStatus','getBaseUrl'
    ])
  },
  created() {
    console.log("snono nell'app created")
    axios
    .get('/ccb/public/getCCFUrl', store.getters.authHeader)
    .then(response => {
      this.setBaseUrl(response.data)
    })
    .catch(error => {
      console.log(error);
    })
  }
}
</script>

<style lang="scss">
  $fa-font-path: "../node_modules/font-awesome/fonts";
  $mdi-font-path: "../node_modules/mdi/fonts";
  $flag-icon-css-path: "../node_modules/flag-icon-css/flags";
  @import "../node_modules/mdi/scss/materialdesignicons.scss";
  @import "../node_modules/flag-icon-css/sass/flag-icon.scss";
  @import "../node_modules/font-awesome/scss/font-awesome.scss";
  @import "./assets/scss/style";
</style>
